// @flow

// Libs
import React, { Component } from 'react'

// Components
import Button from '@react-mdc/button'
import ImportJobsFormFields from './ImportJobsFormFields'

// Operations
import { ImportJobsToolOperation } from 'hfty-operator-import-jobs-tool/types'

// Constants
import { MSG_FORM_HEADING, MSG_FORM_HINT_MESSAGE, MSG_SUBMIT_BTN, MSG_CANCEL_BTN } from '../constants'

// Localization
import { FormattedMessage } from 'react-intl'
import messages from '../messages'

// Styles
import { message as msgStyles, sidebar } from 'hfty-styles/src/common'

// Types
type Props = {
  updateImportJobsToolOperation: Function,
  importJobsToolOperations: Array<ImportJobsToolOperation>,
  importJobsToolOperation: ImportJobsToolOperation,
  selectedSeason: Object,
  seasonOptions: Array<Object>,
  onCancel: Function,
  onSubmit: Function,
}

export default class ImportJobsForm extends Component {
  props: Props

  constructor(props: Props) {
    super(props)

    this.onSubmit = this.onSubmit.bind(this)
    this.onCancel = this.onCancel.bind(this)
  }

  onSubmit(e: Event) {
    e.preventDefault()

    this.props.onSubmit(this.props.importJobsToolOperations)
  }

  onCancel(e: Event) {
    e.preventDefault()

    this.props.onCancel(this.props.importJobsToolOperations)
  }

  render(): ?React.Element<any> {
    return (
      <div style={sidebar.container}>
        <h3 style={sidebar.h3}>
          <FormattedMessage {...messages[MSG_FORM_HEADING]} />
        </h3>
        <form style={sidebar.form}>
          <p style={msgStyles}>
            <FormattedMessage {...messages[MSG_FORM_HINT_MESSAGE]} />
          </p>
          <ImportJobsFormFields
            importJobsToolOperation={this.props.importJobsToolOperation}
            seasonOptions={this.props.seasonOptions}
            selectedSeason={this.props.selectedSeason}
            updateImportJobsToolOperation={this.props.updateImportJobsToolOperation}
          />
          <div style={sidebar.buttonWrapper}>
            <Button raised primary style={sidebar.button} onClick={this.onSubmit}>
              <FormattedMessage {...messages[MSG_SUBMIT_BTN]} />
            </Button>
            <Button raised onClick={this.onCancel} primary style={{ marginLeft: 10 }}>
              <FormattedMessage {...messages[MSG_CANCEL_BTN]} />
            </Button>
          </div>
        </form>
      </div>
    )
  }
}
